import { t } from "@/i18n-js/instance";
import { useManageAddonModal } from "@circle-react/components/SettingsApp/Plan/AddOns/ManageAddOnsModal";
import { Typography } from "@circle-react/components/shared/uikit/Typography";
import { usePlanStatus } from "@circle-react/hooks/usePlanStatus";
import { Icon } from "@circle-react-shared/Icon";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { Loader } from "@circle-react-uikit/Loader";

interface LimitPanelProps {
  canPurchaseMore?: boolean;
  children: React.ReactNode;
  isLoading: boolean;
  onPurchase: () => void;
  title: string;
  tooltipText?: string;
}

export const LimitPanel = ({
  title,
  children,
  isLoading,
  canPurchaseMore = true,
  onPurchase,
  tooltipText,
}: LimitPanelProps) => {
  const { isCommunityOnTrial } = usePlanStatus();
  const manageAddonsModal = useManageAddonModal();

  const openManageAddonsModal = () => {
    void manageAddonsModal.show({
      onSuccess: onPurchase,
    });
  };

  return (
    <div
      className="bg-primary border-primary relative shrink-0 grow rounded-lg border px-5 py-4"
      data-testid="live-main-status"
    >
      {isLoading ? (
        <div className="flex h-full items-center justify-center">
          <Loader />
        </div>
      ) : (
        <div className="flex h-full flex-col">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-1">
              {title && <Typography.LabelSm>{title}</Typography.LabelSm>}
              {tooltipText && (
                <TippyV2 content={tooltipText}>
                  <Icon type="question-mark" className="icon icon--xs" />
                </TippyV2>
              )}
            </div>
            {!isCommunityOnTrial && canPurchaseMore && (
              <button
                type="button"
                className="cursor-pointer text-sm"
                onClick={openManageAddonsModal}
              >
                {t("live_streams.dashboard.limits.add_more")}
              </button>
            )}
          </div>
          <div className="relative grow">{children}</div>
        </div>
      )}
    </div>
  );
};
